/**
 * @copyright 汽车商贸管理平台 V1.0
 * @year 2026
 * @file http.js
 */
import axios from 'axios'
import store from '@/store/index.js'
import router from '../router'
import { Toast } from "vant";
import baseUrl from './baseURL'

const http = {}

// 创建 axios 实例，设置超时时间
var instance = axios.create({
    baseURL: baseUrl,
    timeout: 300000  // 5分钟，支持大文件上传
})

// 弹窗防抖标志位
let isRedirecting = false;

// 请求拦截器：自动添加 token 到请求头
instance.interceptors.request.use(
    function(config) {
        // 从 localStorage 或 sessionStorage 获取 token
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        return config
    },
    function(error) {
        router.push('/login')
        return Promise.reject(error)
    }
)

/**
 * [修复] 响应拦截器存在多个问题：
 * 1. this.$router.push 在此处无法正常工作（this 不指向 Vue 实例）
 * 2. Toast.warning 在 Vant 中不存在，应该使用 Toast.fail
 * 3. 移除了未使用的 Message 组件
 */
instance.interceptors.response.use(
    response => {
        return response.data
    },
    err => {
        if (err && err.response) {
            switch (err.response.status) {
                case 400:
                    err.message = err.response.data || '请求出错'
                    break
                case 401:
                    // [修复] 使用导入的 router 变量，而不是 this.$router
                    if (!isRedirecting) {
                        isRedirecting = true;
                        Toast.fail('授权失败，请重新登录');
                        store.commit('LOGIN_OUT');
                        router.push('/login').finally(() => {
                            // 路由跳转完成后，重置标志位
                            setTimeout(() => { isRedirecting = false; }, 1000);
                        });}
                    break
                case 403:
                    err.message = '拒绝访问'
                    break
                case 404:
                    err.message = '请求错误，未找到该资源'
                    break
                case 500:
                    err.message = '服务器端出错'
                    break
                default:
                    err.message = '请求失败'
            }
        } else {
            err.message = '连接服务器失败'
        }
        // [修复] Toast.warning 改为 Toast.fail（Vant 的正确用法）
        Toast.fail(err.message)
        return Promise.reject(err)
    }
)

/**
 * [修复] 封装 get/post/delete 方法，统一处理响应
 * 原因：原代码在 http 方法中重复处理了响应逻辑，应该在拦截器中统一处理
 */
http.get = async function(url, options) {
    try {
        const response = await instance.get(url, options)
        return response
    } catch (e) {
        console.error("http.get error:", e)
        throw e
    }
}

http.post = async function(url, data, options) {
    try {
        const response = await instance.post(url, data, options)
        return response
    } catch (e) {
        console.error("http.post error:", e)
        throw e
    }
}

http.delete = async function(url, options) {
    try {
        const response = await instance.delete(url, options)
        return response
    } catch (e) {
        console.error("http.delete error:", e)
        throw e
    }
}

export default http
